var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.619873,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#1877F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.619873,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#F0F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0153 18.5768V14.0369H14.5289L14.8171 12.1587H13.0153V10.9397C13.0153 10.4257 13.2673 9.92582 14.0739 9.92582H14.8935V8.32809C14.8935 8.32809 14.1503 8.20042 13.4398 8.20042C11.9545 8.20042 10.9854 9.09969 10.9854 10.728V12.1587H9.33533V14.0369H10.9854V18.5768C7.88059 18.089 5.50586 15.4011 5.50586 12.1588C5.50579 8.57042 8.41206 5.66309 12.0003 5.66309C15.5886 5.66309 18.4959 8.57035 18.4959 12.1587C18.4959 15.401 16.1212 18.089 13.0153 18.5768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.c3773cd938a0dcf18c87122d345e1e3e.svg";
export { ForwardRef as ReactComponent };